module.exports = __webpack_public_path__ + "img/language-translate.e6e6a250.svg";